export const saveMessages = [
  "Added to your mood library 💛",
  "You have beautiful choice 🌼",
  "Great pick this suits your vibe ✨",
  "This memory is yours now 🤍",
  "Saved to your vibes 🌿",
  // "A little joy added to your day 💫",
  "You have amazing taste 🔥",
  "You have great taste 🔥",
  // "Collected — keep building your vibe 💚",
  "Keep building your vibe 💚",
  "Calm energy unlocked 🌙",
  
];